(() => {
  function init(root) {
    if (root.dataset.giftReady) return;
    root.dataset.giftReady = 'true';
    const form = root.querySelector('.vics-gifts__form');
    if (!form) return;
    const select = form.querySelector('[data-gift-variant]');
    const price = root.querySelector('[data-gift-price]');
    const submit = form.querySelector('[data-gift-submit]');
    const quantity = form.querySelector('[name="quantity"]');
    const recipient = form.querySelector('[data-gift-recipient]');
    const fields = form.querySelector('[data-gift-fields]');
    const error = form.querySelector('[data-gift-error]');
    const refresh = () => {
      const option = select.selectedOptions[0];
      price.textContent = option.dataset.money;
      submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? 'Unavailable' : 'Add to cart';
    };
    select.addEventListener('change', refresh);
    recipient.addEventListener('change', () => {
      fields.hidden = !recipient.checked;
      fields.disabled = !recipient.checked;
      fields.querySelector('[data-gift-offset]').value = String(new Date().getTimezoneOffset());
      if (recipient.checked) fields.querySelector('input[type="email"]').focus();
    });
    const decrease = form.querySelector('[data-gift-quantity="-1"]');
    const refreshQuantity = () => { decrease.disabled = Number(quantity.value) <= 1; };
    form.querySelectorAll('[data-gift-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.giftQuantity)));
        refreshQuantity();
      });
    });
    quantity.addEventListener('input', refreshQuantity);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || submit.disabled) return;
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Adding to cart…';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart/add.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this gift card. Please check the details and try again.');
        window.location.assign(form.querySelector('[name="return_to"]').value);
      } catch (failure) {
        error.textContent = failure.message || 'Unable to add this gift card. Please try again.';
        error.hidden = false;
        refresh();
      }
    });
    refresh();
    refreshQuantity();
  }
  document.querySelectorAll('[data-vics-gifts]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vics-gifts]').forEach(init));
})();
